import React, { memo, useEffect, useState } from "react"
import CardVod from "components/CardVod"
import Link from "next/link"
import TypeEvent from "utils/TypeEvent"
import DisplayTypeScreenBlock from "utils/DisplayTypeScreenBlock"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"
import { Navigation } from "swiper"
import CardTopic from "components/CardTopic"
// eslint-disable-next-line react/display-name
const MySwiper = memo(({ name, contents, id, type_block, display_type }) => {
  const [deVice, setDeVice] = useState("desktop")
  function onChangePerView() {
    if (deVice === "mobile") {
      return 1.8
    } else if (deVice === "ipad") {
      return 3.25
    } else {
      return 4.6
    }
  }

  function onChangePerGroup() {
    if (deVice === "mobile") {
      return 1
    } else if (deVice === "ipad") {
      return 3
    } else {
      return 4
    }
  }
  useEffect(() => {
    if (window.innerWidth < 768) {
      setDeVice("mobile")
    } else if (window.innerWidth >= 768 && window.innerWidth < 980) {
      setDeVice("ipad")
    } else {
      setDeVice("desktop")
    }
  })
  return (
    <div className="mb-4 md:mb-4 lg:mb-6 ">
      <div>
        <h2 className="relative mb-2 md:mb-2 text-sm md:text-lg lg:text-xl font-semibold mt-2">
          <Link href={`/category/detail/${id}`}>
            <div className="text-dark-100 flex items-center wapper_see_more">
              <span className="uppercase mr-4">{name}</span>{" "}
              <div className="text-primary-500 text-sm flex items-center see_more">
                <span>Xem thêm</span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M13 17L18 12L13 7"
                    stroke="#66A7FF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6 17L11 12L6 7"
                    stroke="#66A7FF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
          </Link>
        </h2>
        <div className="relative wapper__swiper__custom">
          <Swiper
            key={"vod"}
            slidesPerView={onChangePerView()}
            slidesPerGroup={onChangePerGroup()}
            spaceBetween={16}
            modules={[Navigation]}
            className="mySwiper"
            navigation={true}
          >
            {contents?.length > 0 &&
              contents?.map((item) => {
                const { id, is_live } = item
                return (
                  <SwiperSlide key={id}>
                    <CardTopic {...item} display_type={0} showTime={is_live ? true : false} />
                  </SwiperSlide>
                )
              })}
          </Swiper>
        </div>
      </div>
    </div>
  )
})

export default MySwiper
